// src/components/AddUserModal.js
import { FaTimes, FaPlus } from "react-icons/fa";

function AddUserModal({
  show,
  creatingUser,
  newUser,
  setNewUser,
  createUser,
  close,
  error,
  success,
  phoneOk,
  normalizedForHint,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/45"
        onClick={() => !creatingUser && close()}
      />

      <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl">
        {/* Header */}
        <div className="flex justify-between p-4 border-b">
          <h3 className="font-extrabold">➕ إضافة مستخدم جديد</h3>
          <button onClick={close}>
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 space-y-4">
          {error && <div className="text-red-600">{error}</div>}
          {success && <div className="text-green-600">{success}</div>}

          <input
            placeholder="الاسم"
            value={newUser.name}
            onChange={(e) =>
              setNewUser((p) => ({ ...p, name: e.target.value }))
            }
            className="w-full border p-3 rounded-xl"
          />

          <input
            placeholder="الإيميل"
            value={newUser.email}
            onChange={(e) =>
              setNewUser((p) => ({ ...p, email: e.target.value }))
            }
            className="w-full border p-3 rounded-xl"
          />

          <input
            placeholder="رقم الموبايل"
            value={newUser.phone}
            onChange={(e) =>
              setNewUser((p) => ({ ...p, phone: e.target.value }))
            }
            className="w-full border p-3 rounded-xl"
          />

          <small className={phoneOk ? "text-green-600" : "text-red-600"}>
            {phoneOk
              ? `✔ صحيح (${normalizedForHint})`
              : "❌ رقم غير صحيح"}
          </small>

          <input
            type="password"
            placeholder="كلمة المرور"
            value={newUser.password}
            onChange={(e) =>
              setNewUser((p) => ({ ...p, password: e.target.value }))
            }
            className="w-full border p-3 rounded-xl"
          />

          <button
            onClick={createUser}
            disabled={creatingUser}
            className="w-full bg-blue-600 text-white py-3 rounded-xl"
          >
            <FaPlus /> {creatingUser ? "جاري الإنشاء..." : "إنشاء المستخدم"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddUserModal;
